import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-0"}],["path",{"d":"M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2","key":"svg-1"}],["path",{"d":"M16 3.13a4 4 0 0 1 0 7.75","key":"svg-2"}],["path",{"d":"M21 21v-2a4 4 0 0 0 -3 -3.85","key":"svg-3"}]]

const IconUsers = createReactComponent('outline', 'users', 'Users', __iconNode);

export default IconUsers;